import type { Timestamp } from "@firebase/firestore-types";
import type {
  PublicKeyCredentialCreationOptionsJSON,
  PublicKeyCredentialRequestOptionsJSON,
} from "@simplewebauthn/server";
import type {
  TreezorKycLiveness,
  SCAWallet as TreezorSCAWallet,
  UserWithKyc as TreezorUser,
} from "../treezor/index.js";

/**
 * Public user data, accessible to other users
 */
export const usersFullPath = "users";
export const userFullPath = (uid: string): string => `${usersFullPath}/${uid}`;

export type User = {
  email: string;
  uid: string;
  createdAt: Timestamp;
  lastSignInAt?: Timestamp;
  /**
   * Accounts where the user is in `userIds`. Used by Firestore rules.
   */
  accountIds?: string[];
};

/**
 * Private user data, only accessible by the backend
 */
export const userPrivateCollectionGroup = "private";
export const userPrivatePathFromUser = `${userPrivateCollectionGroup}/0`;
export const userPrivateFullPath = (uid: string) =>
  [userFullPath(uid), userPrivatePathFromUser].join("/");

export type UserPrivate = {
  webAuthnRegistrationOptions?: PublicKeyCredentialCreationOptionsJSON;
  webAuthnAuthenticationOptions?: PublicKeyCredentialRequestOptionsJSON;
  treezorUserAccessToken?: {
    token: string;
    expiresAt: Timestamp;
  };
  treezorUser?: TreezorUser;
  treezorSCAWallets?: Record<string, TreezorSCAWallet>;
  treezorKycLiveness?: TreezorKycLiveness;
};
